import { Link, useLocation } from "react-router-dom";

export default function Breadcrumb() {
  const location = useLocation();

  const paths = location.pathname.split("/").filter(Boolean);

  return (
    <div className="flex items-center text-sm text-gray-500 mb-2">

      {/* HOME */}
      <Link to="/" className="hover:text-gray-800">
        Home
      </Link>

      {paths.map((p, i) => (
        <div key={i} className="flex items-center">

          <span className="mx-2 text-gray-300">/</span>

          <span className="capitalize text-gray-700">
            {p}
          </span>

        </div>
      ))}

    </div>
  );
}